import { modularScale } from 'polished';

export default (steps: number) => modularScale(steps, '1em', 'minorThird');
